<template>
  <div class="pbr-analysis-content">
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.opportunityAnalysis.businessOpportunityCountryTrendChart') }}</span>
          <div class="pbr-analysis-echart-div" id="country-trend"></div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.opportunityAnalysis.businessOpportunityTypeTrendChart') }}</span>
          <div class="pbr-analysis-echart-div" id="type-trend"></div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.opportunityAnalysis.businessOpportunityCountryDistributionMap') }}</span>
          <div class="pbr-analysis-echart-div" id="country-distribution"></div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.opportunityAnalysis.businessOpportunityTypeDistributionMap') }}</span>
          <div class="pbr-analysis-echart-div" id="type-distribution"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
    import * as echarts from 'echarts';
    import {pieChartOption, xLabelColor, chartLineOption} from "./constant";
    import ResizeObserver from 'resize-observer-polyfill'

    let countryTrendChart;
    let countryDistributionChart;
    let typeTrendChart;
    let typeDistributionChart;

    export default {
        name: "BusinessOpportunityAnalysis", // 商机分析
        props: ['condition', 'exportSuccess'],
        components: {},

        data() {
            return {
                countryDistributionData: {},
                typeDistributionData: {},
                queryParams: {},
                isResize: false,
            }
        },
        mounted() {
            window.addEventListener('resize',  () => {
              this.isResize = true;
            })
            this.queryParams = this.condition;
            this.initEcharts();
            this.echartTheme();
            this.search();
        },
        methods: {
            getTheme() {
                return this.$store.state.brpaModule.theme || 'white';
            },
            initEcharts() {
                let countContrastDom = document.getElementById('country-trend')

                countryTrendChart = echarts.init(countContrastDom);
                countryTrendChart.setOption(chartLineOption);
                countryDistributionChart = echarts.init(document.getElementById("country-distribution"));
                countryDistributionChart.setOption(pieChartOption);
                typeTrendChart = echarts.init(document.getElementById("type-trend"));
                typeTrendChart.setOption(chartLineOption);
                typeDistributionChart = echarts.init(document.getElementById("type-distribution"));
                typeDistributionChart.setOption(pieChartOption);

                let that = this;
                let countContrastObserver = new ResizeObserver((entries) => {
                  if (that.isResize) {
                    that.resize();
                    if (entries && entries.length > 0 && entries[0].borderBoxSize[0].blockSize > 0) {
                      that.isResize = false;
                    }
                  }
                })
                countContrastObserver.observe(countContrastDom);
            },

            countryTrendHandler(obj) {
                if (obj.length<=0){
                    countryTrendChart.clear();
                    return ;
                }
                let series = [];
                for (let i = 0; i < obj.length; i++) {
                    let ser = {};
                    ser["name"] = obj[i].name;
                    ser["data"] = obj[i].nums;
                    ser["type"] = "line";
                    ser["smooth"] = true;
                    series[i] = ser;
                }
                const option = {
                    title: {
                      subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.tiao')} `,
                      top: 15
                    },
                    legend: {
                        pageIconColor: xLabelColor[this.getTheme()],
                        pageTextStyle: {
                            color:xLabelColor[this.getTheme()],
                        },
                        textStyle: {
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    yAxis: {
                        minInterval: 1,
                        boundaryGap : [ 0, 0.1 ],
                        axisLabel:{
                            color: xLabelColor[this.getTheme()],
                        },
                      min: function (value) {
                        let num = 0
                        if (value.min === 0) {
                          return num
                        } else if (value.min.toString().length < 2) {
                          return value.min - 1
                        } else if (value.min.toString().length < 3) {
                          return value.min - 10
                        } else {
                          num = 10 ** (value.min.toString().length - 2)
                          return Math.floor(value.min / num) * num
                        }
                      }
                    },
                    xAxis: {
                        data: obj[0].times,
                        axisLabel: {
                            color: xLabelColor[this.getTheme()],
                        },
                    },
                    series: series,
                };

                countryTrendChart.clear();
                countryTrendChart.setOption(chartLineOption);
                countryTrendChart.setOption(option);
            },

            countryDistributionHandler() {
                if (this.countryDistributionData.length<=0){
                    countryDistributionChart.clear();
                    return ;
                }
                let series = [];
                for (let i = 0; i < this.countryDistributionData.length; i++) {
                    let ser = {};
                    ser["name"] = this.countryDistributionData[i].name;
                    ser["value"] = this.countryDistributionData[i].num;
                    series[i] = ser;
                }
                const option = {
                    legend: {
                        pageIconColor: xLabelColor[this.getTheme()],
                        pageTextStyle: {
                            color:xLabelColor[this.getTheme()],
                        },
                        textStyle: {
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    series: [
                        {
                            type: 'pie',
                            top: '10%',
                            radius: '70%',
                            data: series,
                            label: {
                                show: true,
                                color: xLabelColor[this.getTheme()],
                                formatter: '{d}%'
                            },
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };
                countryDistributionChart.clear();
                countryDistributionChart.setOption(pieChartOption);
                countryDistributionChart.setOption(option);
            },

            typeTrendHandler(obj) {
                if (obj.length<=0){
                    typeTrendChart.clear();
                    return ;
                }
                let series = [];
                for (let i = 0; i < obj.length; i++) {
                    let ser = {};
                    ser["name"] = obj[i].name;
                    ser["data"] = obj[i].nums;
                    ser["type"] = "line";
                    ser["smooth"] = true;
                    series[i] = ser;
                }
                const option = {
                    title: {
                      subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.tiao')} `,
                      top: 15
                    },
                    legend: {
                        pageIconColor: xLabelColor[this.getTheme()],
                        pageTextStyle: {
                            color:xLabelColor[this.getTheme()],
                        },
                        textStyle: {
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    yAxis: {
                        minInterval: 1,
                        boundaryGap : [ 0, 0.1 ],
                        axisLabel:{
                            color: xLabelColor[this.getTheme()],
                        },
                      min: function (value) {
                        let num = 0
                        if (value.min === 0) {
                          return num
                        } else if (value.min.toString().length < 2) {
                          return value.min - 1
                        } else if (value.min.toString().length < 3) {
                          return value.min - 10
                        } else {
                          num = 10 ** (value.min.toString().length - 2)
                          return Math.floor(value.min / num) * num
                        }
                      }
                    },
                    xAxis: {
                        data: obj[0].times,
                        axisLabel:{
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    series: series,
                };
                typeTrendChart.clear();
                typeTrendChart.setOption(chartLineOption);
                typeTrendChart.setOption(option);
            },

            typeDistributionHandler() {
                if (this.typeDistributionData.length<=0){
                    typeDistributionChart.clear();
                    return ;
                }
                let series = [];
                for (let i = 0; i < this.typeDistributionData.length; i++) {
                    let ser = {};
                    ser["name"] = this.typeDistributionData[i].name;
                    ser["value"] = this.typeDistributionData[i].num;
                    series[i] = ser;
                }
                const option = {
                    legend: {
                        pageIconColor: xLabelColor[this.getTheme()],
                        pageTextStyle: {
                            color:xLabelColor[this.getTheme()],
                        },
                        textStyle: {
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    series: [
                        {
                            type: 'pie',
                            top: '10%',
                            radius: '70%',
                            data: series,
                            label: {
                                show: true,
                                color: xLabelColor[this.getTheme()],
                                formatter: '{d}%'
                            },
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };
                typeDistributionChart.clear();
                typeDistributionChart.setOption(pieChartOption);
                typeDistributionChart.setOption(option);
            },

            echartTheme() {
                const option = {
                    legend: {
                        pageIconColor: xLabelColor[this.getTheme()],
                        pageTextStyle: {
                            color:xLabelColor[this.getTheme()],
                        },
                        textStyle: {
                            color:xLabelColor[this.getTheme()],
                        }
                    },
                    xAxis: {
                        axisLabel: {
                            color: xLabelColor[this.getTheme()],
                        },
                    },
                    yAxis: {
                        axisLabel: {
                            color: xLabelColor[this.getTheme()],
                        },
                    },
                };
                if(countryTrendChart){
                    countryTrendChart.setOption(option);
                }

                if(countryDistributionChart){
                    const pieOption = {
                        legend: {
                            textStyle: {
                                color: xLabelColor[this.getTheme()],
                            }
                        },
                    }
                    countryDistributionChart.setOption(pieOption);
                }

                if (typeTrendChart){
                    typeTrendChart.setOption(option);
                }
                if (typeDistributionChart){
                    const pieOption = {
                        legend: {
                            textStyle: {
                                color: xLabelColor[this.getTheme()],
                            }
                        },
                    }
                    typeDistributionChart.setOption(pieOption);
                }
            },

            /**/
            search(){
              countryTrendChart.showLoading({ text: this.$t('loading'),maskColor: 'transparent', textColor: xLabelColor[this.getTheme()], });
              countryDistributionChart.showLoading({ text: this.$t('loading'),maskColor: 'transparent', textColor: xLabelColor[this.getTheme()], })
              typeTrendChart.showLoading({ text: this.$t('loading'),maskColor: 'transparent', textColor: xLabelColor[this.getTheme()], });
              typeDistributionChart.showLoading({ text: this.$t('loading'),maskColor: 'transparent', textColor: xLabelColor[this.getTheme()], });
                let param = {
                    from: 'cn',
                    module: 'sj' , // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
                };
                param = Object.assign(param, this.queryParams);
                this.$pbrAxios.post('/front/analyses/search',param).then((data) => {
                    let success = data.success;
                    if (success){
                        let numModels = data.result.numModels;
                        this.countryDistributionData = data.result.nationModels;
                        let typeLineModels = data.result.typeLineModels;
                        this.typeDistributionData = data.result.typeModels;

                        this.countryTrendHandler(numModels);
                        this.countryDistributionHandler();
                        this.typeTrendHandler(typeLineModels);
                        this.typeDistributionHandler();
                    } else {

                    }
                }).finally(() => {
                    this.$emit("closeShow");
                  countryTrendChart.hideLoading();
                  countryDistributionChart.hideLoading()
                  typeTrendChart.hideLoading();
                  typeDistributionChart.hideLoading();
                })
            },
            /**/
            hsearch(){
                let param = {
                    from: 'cn',
                    module: 'sj' , // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
                };
                param = Object.assign(param, this.queryParams);

                console.log(param);

                this.$pbrAxios.post('/front/analyses/hsearch',param).then(data => {
                    let success = data.success;
                    if (success){
                        let numModels = data.result.numModels;
                        this.countryDistributionData = data.result.nationModels;
                        let typeLineModels = data.result.typeLineModels;
                        this.typeDistributionData = data.result.typeModels;

                        this.countryTrendHandler(numModels);
                        this.countryDistributionHandler();
                        this.typeTrendHandler(typeLineModels);
                        this.typeDistributionHandler();

                    } else {

                    }
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.$emit("closeShow");
                });
            },

            resize() {
              if (countryTrendChart!=null)
                countryTrendChart.resize();
              if (countryDistributionChart!=null)
                countryDistributionChart.resize();
              if (typeTrendChart!=null)
                typeTrendChart.resize();
              if (typeDistributionChart!=null)
                typeDistributionChart.resize();
            }
        },
        activated() {
          this.isResize = true;
          this.resize();
        },
        destroyed () {
          window.removeEventListener('resize',() => {
            this.isResize = false;
          })
        },
        watch: {
            '$store.state.brpaModule.theme': {
                handler: function (val) {
                    if(countryDistributionChart){
                        this.countryDistributionHandler();
                    }
                    if(typeDistributionChart){
                        this.typeDistributionHandler();
                    }
                    this.echartTheme();
                }
            },
            condition: function(newval){
                this.queryParams = newval;
                if (this.queryParams.id){
                    this.hsearch();
                }else{
                    this.search();
                }
            },
            exportSuccess: function(newval){
              this.resize();
            }
        },
    }
</script>

<style scoped>
  .row {
    margin-top: 16px;
  }

  .row2 {
    margin-top: 32px;
  }

  .divCol {
    align-items: center;
    text-align: center
  }
</style>
